import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const Mensaje=(msg, tipo, position="bottom-right", autoClose=5000)=>{
    const config_toast = {   position: position ,autoClose: autoClose,hideProgressBar: false,closeOnClick: true,pauseOnHover: true,draggable: true,progress: undefined,theme: "colored",}; //transition: 'bounce',}
   
    switch (tipo) {
        case "success":
            toast.success(msg, config_toast);
            break;
        case "error":
            toast.error(msg, config_toast);
            break;
        case "info":
            toast.info(msg, config_toast);
            break;
        case "warning":
            toast.warn(msg, config_toast);
            break;  
        default:
            toast("[no hay mensaje]", config_toast);
            break;
    } 
}
